export enum PeriodDepreciationCalculated {
  Monthly = 0,
  Daily_YearsAreEqual = 1,
  Daily_DaysAreEqual = 2,
}
